import React, { useState, useEffect, useMemo } from 'react'
import { NavBar } from '../components/nav-bar'
import { Carousel } from '../components/carousel'
import { AssetCard } from '../components/asset-card'
import { AssetBox } from '../components/asset-box'
import { ContactInfo } from '../components/contact-info'
import { AnimateOnScroll } from '../components/animate-on-scroll'
import aboutUsImage from '../assets/about-us-img.jpeg'
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { db, products_col_name, categories_col_name, promotions_col_name } from '../firebase';
import { collection, query, orderBy, getDocs, where, limit } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { Footer } from '../components/footer'
import ReactPlayer from 'react-player'
import { brandName } from '../modules/modules'


const Home = () => {
    const { t } = useTranslation();
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [promotionProducts, setPromotionProducts] = useState([]);
    const [index, setIndex] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const [promotionTitle, setPromotionTitle] = useState('');

    useEffect(() => {
        const fetchPromotionTitle = async () => {
            try {
                const snapshot = await getDocs(collection(db, promotions_col_name));
                if (!snapshot.empty) {
                    setPromotionTitle(snapshot.docs[0].data().title || '');
                }
            } catch (error) {
                console.error("Error fetching promotion title:", error);
            }
        };
        fetchPromotionTitle();
    }, []);

    useEffect(() => {
        const fetchProducts = async () => {
            const q = query(collection(db, products_col_name), orderBy("createdAt", "desc"), limit(8));
            const querySnapshot = await getDocs(q);
            const productsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setProducts(productsData);
        };
        fetchProducts();
    }, []);

    useEffect(() => {
        const fetchPromotionProducts = async () => {
            try {
                const q = query(
                    collection(db, products_col_name),
                    where("onPromotion", "==", true),
                    orderBy("onPromotionStartDate", "desc"),
                    limit(10)
                );
                const querySnapshot = await getDocs(q);
                const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setPromotionProducts(data);
            } catch (err) {
                console.error('Error fetching promotion products:', err);
                try {
                    const qAll = query(collection(db, products_col_name), orderBy("createdAt", "asc"));
                    const snapAll = await getDocs(qAll);
                    const dataAll = snapAll.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                    setPromotionProducts(dataAll.filter(p => p?.onPromotion === true).slice(0, 10));
                } catch (fallbackErr) {
                    console.error('Fallback promotion fetch failed:', fallbackErr);
                }
            }
        };
        fetchPromotionProducts();
    }, []);

    useEffect(() => {
        const fetchCategories = async () => {
            const snapshot = await getDocs(collection(db, categories_col_name));
            const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setCategories(list);
        };
        fetchCategories();
    }, []);

    const filteredProducts = useMemo(() => {
        if (!selectedCategory || selectedCategory === 'all') return products;
        return products.filter(
            p => p.category?.toLowerCase().trim() === selectedCategory.toLowerCase().trim()
        );
    }, [products, selectedCategory]);



    useEffect(() => {
        if (isHovered) return;
        const interval = setInterval(() => {
            setIndex((prev) =>
                prev === promotionProducts.length - 1 ? 0 : prev + 1
            );
        }, 2500); // speed
        return () => clearInterval(interval);
    }, [isHovered]);

    useEffect(() => {
        if (index >= products.length) {
            setTimeout(() => setIndex(0), 100);
        }
    }, [index]);

    return (
        <>
            <hamlet>
                <title>{brandName}</title>
                <meta name='description' content="karibu daty abaya tz kujionea aina mbali mbali za ma abaya mazuri na yakisasa kutoka dubai" />
                <meta name='description' content="Welcome to Daty Abaya TZ to explore a variety of beautiful and modern abayas from Dubai." />
            </hamlet>
            <header>
                <div className="brand-title">
                    <h1>{brandName}</h1>
                </div>
                <div className="fixed-header">
                    <NavBar is_welcome_page="#0303fc" />
                </div>

            </header>
            {/* // main */}
            <main>
                <section>
                    {/* TODO: about daty abaya */}
                    <Carousel />
                </section>
                <p className="lined-text" style={{ color: "#fca103ff" }}>stara in beauty</p>
                <AnimateOnScroll>
                    <section className="about-section">
                        <div className='about-us'>
                            <div className="about-us__image-wrap">
                                <img src={aboutUsImage} alt="DATY Abaya - Elegant traditional wear" />
                            </div>
                            <div className="about-us__content">
                                <h2 className="about-us__title">{t("about-us")}</h2>
                                <p className="about-us__lead">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod.</p>
                                <div className="about-us__body">
                                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Veritatis cumque ex fugit. Rem laborum ipsam consectetur quibusdam soluta nisi velit, laudantium expedita distinctio optio aspernatur suscipit, cupiditate exercitationem corporis autem?
                                        Vero fugiat quisquam adipisci repellat eos, omnis ipsum tempore voluptas eaque exercitationem error animi tempora fugit quaerat necessitatibus odio alias obcaecati molestias aperiam dolorum consequatur suscipit sint explicabo veniam? Architecto!
                                        Unde sunt repellat dolorum deserunt veniam in iusto, officiis eveniet et corporis deleniti! Saepe, hic! Iusto sit laudantium voluptatibus recusandae, repellat error animi quisquam ex totam, dicta ipsam, aperiam nemo!temporibus magnam voluptatum asperiores. Eius accusamus asperiores porro qui illo commodi. Eius enim error odio, nobis assumenda omnis illo impedit? Possimus?</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </AnimateOnScroll>
                <AnimateOnScroll>
                    {promotionProducts.length > 0 && (
                    <section className="on-promotion-section">
                        {/* TODO: on promotion or new stock products display */}
                        <h1 className="lined-text">{promotionTitle.toUpperCase()}</h1>
                        <div className="on-promotion"
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}>
                            <div className="on-promotion__track"
                                style={{ transform: `translateX(-${index * 250}px)` }}
                            >
                                {promotionProducts.length > 0 ? (
                                    promotionProducts.map((p) => (
                                        <a href={`/product/${p.id}/${encodeURIComponent(p.name)}/${encodeURIComponent(p.desc)}/${encodeURIComponent(p.coverImage)}/`} style={{"textDecoration":"none"}}>
                                        <AssetCard
                                            key={p.id}
                                            thumbnail={p.coverImage || p.image}
                                            title={p.name}
                                            oldPrice={p.price}
                                            newPrice={p.promotionPrice != null ? p.promotionPrice : p.price}
                                        />
                                        </a>
                                    ))
                                ) : (
                                    <p>No products on promotion</p>
                                )}
                            </div>
                        </div>
                    </section>
                    )}
                </AnimateOnScroll>
                <AnimateOnScroll>
                    <section className="products-on-sell-section">
                        <h1 className="lined-text" style={{ color: "#0320fcff" }}>{t("products-on-selling").toUpperCase()}</h1>
                        <div className="products-on-selling-categories" role="tablist" aria-label="Filter products by category">
                            <button
                                className={`category-pill ${selectedCategory === 'all' ? 'active' : ''}`}
                                onClick={() => setSelectedCategory('all')}
                                type="button"
                            >
                                {t("all") || "All"}
                            </button>
                            {categories.map((cat) => (
                                <button
                                    key={cat.id}
                                    className={`category-pill ${selectedCategory.toLowerCase() === cat.name?.toLowerCase() ? 'active' : ''}`}
                                    onClick={() => setSelectedCategory(cat.name || '')}
                                    type="button"
                                >
                                    {cat.name}
                                </button>
                            ))}
                            <button
                                className={`category-pill`}
                                onClick={() => setSelectedCategory('all')}
                                type="button"
                            >
                                <Link to="/products" target='_parent' style={{ textDecoration: 'none' }}>{t("view-all") || "View All"}</Link>
                            </button>
                        </div>
                        <div className="products-on-selling">
                            {filteredProducts.length > 0 ? (
                                filteredProducts.map(product => (
                                    <AssetBox key={product.id} product={product} />
                                ))
                            ) : (
                                <div className="products-on-selling-empty">
                                    <p>{selectedCategory === 'all'
                                        ? (t("no-products") || "No products yet.")
                                        : (t("no-products-in-category") || `No products in this category.`)}</p>
                                </div>
                            )}
                        </div>
                    </section>
                </AnimateOnScroll>
                <AnimateOnScroll>
                    <ContactInfo />
                </AnimateOnScroll>
            </main>
            {/* // footer */}
            <footer>
                <Footer />
            </footer>
        </>
    )
}

export default Home

